module.exports = "https://static.weeecdn.net/masgusto-mweb/_next/static/images/latino-logo-09eae597ab9f217c8251d058e9b52f6a.svg";